export default function SliderPopup({ wrapper, onClose }) {
  const sliderPopupContainer = '.js-scout-slider-popup__container';
  const closeIconSelector = '.js-scout-slider-popup__close';
  const overlaySelector = '.js-scout-slider-popup__overlay';
  let dialog;
  let overlay;

  function getDialog() {
    if (!dialog) dialog = document.querySelector(`${wrapper} dialog`);
    return dialog;
  }

  function getOverlay() {
    if (!overlay) overlay = document.querySelector(`${wrapper} ${overlaySelector}`);
    return overlay;
  }

  function hideDialog(event) {
    event?.stopPropagation();
    const dialogElement = getDialog();
    if (!dialogElement.open) return;

    // Hide the dialog
    dialogElement.removeAttribute('open');
    document.querySelector(`${wrapper}`).classList.add('hid');

    // Hide the overlay if it exists
    const overlayElement = getOverlay();
    if (overlayElement) {
      overlayElement.style.display = 'none';
    }

    onClose?.();
  }

  function handleWrapperClick(e) {
    // Only close if clicking on the wrapper or overlay, not on the container or its children
    const container = document.querySelector(`${wrapper} ${sliderPopupContainer}`);
    if (!container.contains(e.target) || e.target.matches(overlaySelector)) {
      hideDialog(e);
    }
  }

  function initialize() {
    // The close button should always close the popup
    document.querySelector(`${wrapper} ${closeIconSelector}`).addEventListener('click', hideDialog);
    // Handle wrapper clicks specially to allow clicks inside the popup to work
    document.querySelector(`${wrapper}`).addEventListener('click', handleWrapperClick);
    // Add explicit click event for the overlay if it exists
    const overlayElement = getOverlay();
    if (overlayElement) {
      overlayElement.addEventListener('click', hideDialog);
    }
  }

  function openDialog() {
    // Show the dialog
    const dialogElement = getDialog();
    dialogElement.setAttribute('open', '');
    document.querySelector(`${wrapper}`).classList.remove('hid');

    // Show the overlay if it exists
    const overlayElement = getOverlay();
    if (overlayElement) {
      overlayElement.style.display = 'block';
    }
  }

  return { initialize, openDialog, hideDialog };
}
